/* ============================================================================
   Ancona Pass 25 — motion layer JS (ancona-motion.js)  [L6]
   Add-to-cart confirmation beat: subscribes to the theme's own pub/sub bus
   (PUB_SUB_EVENTS.cartUpdate, published by product-form.js with
   source: 'product-form' — quick-add included) and, for 1400ms, swaps the
   submitting button's label to "Added to cart" (the theme's lexicon — never
   "Bag") and applies the .ancona-atc-confirm class whose inked/gold-ring
   visual lives in assets/ancona-motion.css. Reduced-motion users get the
   text swap only — the informational state change always happens; the class
   (and therefore any animation) is applied only under
   prefers-reduced-motion: no-preference. Fires only on confirmed cart adds
   (product-form publishes AFTER a successful /cart/add.js response), so the
   beat can never claim an add that failed.
   Feature flag: this <script> tag's data-ancona-motion attribute (token:
   atc). Absent attribute -> on; empty string -> off. Self-guards: no-op when
   the pub/sub globals are absent.
   Revert: remove the data-ancona-motion line in layout/theme.liquid + this
   file (the motion CSS layer is a separate revert unit).
   ============================================================================ */
(function () {
  'use strict';
  try {
    if (window.__anconaMotion) return;
    window.__anconaMotion = true;

    var script = document.currentScript;
    var featAttr = script ? script.getAttribute('data-ancona-motion') : null;
    /* Absent attribute → on; explicit empty string → off (documented revert path). */
    var FEATURES = (featAttr == null ? 'atc' : featAttr).split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    if (FEATURES.indexOf('atc') === -1) return;

    function boot() {
      /* Graceful no-op when the theme's pub/sub hooks are absent. */
      if (typeof window.subscribe !== 'function' || !window.PUB_SUB_EVENTS || !window.PUB_SUB_EVENTS.cartUpdate) return;
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (evt) {
        try {
          if (!evt || evt.source !== 'product-form') return;
          var vid = evt.productVariantId != null ? String(evt.productVariantId) : '';
          if (!vid) return;
          /* Find the product form that just submitted (variant identity, not
             position — quick-add modals count too). */
          var btn = null;
          var forms = document.querySelectorAll('product-form form');
          Array.prototype.forEach.call(forms, function (f) {
            if (btn) return;
            var idInput = f.querySelector('[name="id"]');
            if (idInput && String(idInput.value) === vid) {
              btn = f.querySelector('.product-form__submit') || f.querySelector('[type="submit"]');
            }
          });
          if (!btn) return;
          var target = btn;
          /* product-form.js publishes cartUpdate BEFORE its .finally() removes
             the loading spinner / aria-disabled state — defer one macrotask so
             the beat starts on the settled button, never under the spinner. */
          window.setTimeout(function () {
            try {
              var span = target.querySelector('span');
              if (!span) return;
              if (target.__anconaAtcTimer) window.clearTimeout(target.__anconaAtcTimer);
              if (target.__anconaAtcOriginal == null) target.__anconaAtcOriginal = span.textContent;
              span.textContent = 'Added to cart';
              /* The visual beat (inked button, 1px gold inset ring — see
                 ancona-motion.css) is motion; the label swap above is information. */
              var motionOK = window.matchMedia && window.matchMedia('(prefers-reduced-motion: no-preference)').matches;
              if (motionOK) target.classList.add('ancona-atc-confirm');
              target.__anconaAtcTimer = window.setTimeout(function () {
                try {
                  if (target.__anconaAtcOriginal != null) span.textContent = target.__anconaAtcOriginal;
                  target.classList.remove('ancona-atc-confirm');
                  target.__anconaAtcTimer = null;
                  target.__anconaAtcOriginal = null;
                } catch (e) {}
              }, 1400);
            } catch (e) { /* the beat must never break the add-to-cart path */ }
          }, 0);
        } catch (e) { /* the beat must never break the add-to-cart path */ }
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
  } catch (e) { /* the motion layer must never break the page */ }
})();
